import { AppConfigSettings } from 'app/core/models/app-config';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class AppConfigService {

	private configSettings!: AppConfigSettings;

	constructor() {}

	setSettings(configSettings: AppConfigSettings): void {
		this.configSettings = configSettings;
	}

	get settings(): AppConfigSettings {
		return this.configSettings;
	}

}